import React from 'react';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { Settings, ShieldCheck, Zap } from 'lucide-react';
export function Capabilities() {
  return <div className="bg-white" data-id="element-337">
      <div className="bg-federal-blue py-16 text-white" data-id="element-338">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-339">
          <h1 className="text-4xl md:text-5xl font-black mb-4" data-id="element-340">
            Technical Capabilities
          </h1>
          <p className="text-white/70 max-w-2xl text-lg" data-id="element-341">
            Engineering resilient infrastructure and accessible digital
            experiences for the modern federal landscape.
          </p>
        </div>
      </div>
      <CompetencyGrid data-id="element-342" />
      <section className="py-16 bg-white border-t border-slate-100" data-id="element-343">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-344">
          <h2 className="text-2xl font-black text-federal-blue mb-12 uppercase tracking-widest text-center" data-id="element-345">
            Our Delivery Methodology
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-346">
            {[{
            icon: Settings,
            title: '01. Discovery & Audit',
            desc: 'Comprehensive assessment of existing infrastructure and compliance gaps.'
          }, {
            icon: ShieldCheck,
            title: '02. Secure Engineering',
            desc: 'Development focused on NIST 800-53 standards and zero-trust architecture.'
          }, {
            icon: Zap,
            title: '03. Rapid Deployment',
            desc: 'Agile delivery cycles with continuous security monitoring and ATO support.'
          }].map((step, i) => <div key={i} className="p-8 border border-slate-200 rounded-sm hover:shadow-lg transition-all" data-id="element-347">
                <step.icon className="w-10 h-10 text-muted-gold mb-6" data-id="element-348" />
                <h3 className="text-xl font-bold text-federal-blue mb-3" data-id="element-349">
                  {step.title}
                </h3>
                <p className="text-tech-slate text-sm leading-relaxed opacity-80" data-id="element-350">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-slate-50" data-id="element-351">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-352">
          <div className="bg-federal-blue p-12 rounded-sm text-white flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-353">
            <div className="max-w-xl" data-id="element-354">
              <h2 className="text-3xl font-black mb-4" data-id="element-355">
                Ready for a Technical Assessment?
              </h2>
              <p className="text-white/70" data-id="element-356">
                Our engineers are ready to review your agency's specific
                requirements and provide a detailed compliance roadmap.
              </p>
            </div>
            <button className="bg-muted-gold hover:bg-gold-hover text-white px-8 py-4 font-bold rounded-sm whitespace-nowrap transition-all" data-id="element-357">
              Schedule Consultation
            </button>
          </div>
        </div>
      </section>
    </div>;
}